import { basicUserInfoConst } from "constants/console/userInfo/basicUserInfoConst";
import { bizUserInfoConst } from "constants/console/userInfo/bizUserInfoConst";
import { bizWriteStateConst } from "constants/console/userInfo/userInfoConst";
import { atom } from "recoil";

// 회원 가입 시 알게된 경로 정보
export const visitUserInfoState = atom({
  key: "visitUserInfoState",
  default: {
    type: "",
    message: "",
    error: "",
  },
});

// 회원 정보
export const basicUserInfoState = atom({
  key: "basicUserInfoState",
  default: basicUserInfoConst,
});

// 사업자 정보
export const bizUserInfoState = atom({
  key: "bizUserInfoState",
  default: bizUserInfoConst,
});

// 사업자 주소 정보
export const bizAddressInfoState = atom({
  key: "bizAddressInfoState",
  default: {
    isopen: false,
    address: {
      juso: "",
      detail: "",
    },
    isLoading: false,
    isComplete: false,
  },
});

// 회원 정보 또는 가입 시 버튼 활성화 변수
export const isUserFormActiveState = atom({
  key: "isUserFormActiveState",
  default: false,
});

// 사업자 작성, 수정
export const bizWriteState = atom({
  key: "bizWriteState",
  default: bizWriteStateConst.init,
});

/**
 * @desc 사용자 정보 로딩 상태
 * 사용자 정보는 본인만 수정할 수 있어 자주 변경되지 않으므로, 첫 페이지 로드 시에만 호출한다.
 */
export const isUserInfoLoadingState = atom({
  key: "isUserLoadingState",
  default: false,
});

// 알림 데이터 상태
export const notiInfoState = atom({
  key: "notiInfoState",
  default: {
    isData: false, // api를 호출했는지 안했는지 여부
    isopen: false, // 리스트를 열었는지 확인 여부
    isAllRead: true, // 모든 알림이 읽음 상태인지 여부
    list: [], // 알림 리스트
  },
});
